export default "__VITE_ASSET__BK7eGT_v__"